import React, { useState, useEffect, useRef } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { message, Select, Input, Button, Popover, Spin } from 'antd';
import { PrinterOutlined, EyeOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import MessageLetter from '../../component/messageLetter/messageLetterDev';
import MessageSalary from '../../component/messageSalary/messageSalary';
import NewMessage from '../../component/newMessage/newMessage';
import { Base } from '../../public/js/base';
import { Config } from '../../public/js/config';
import context from '../../public/js/context';
import { ContextHandler } from '../../public/js/contextHandler';
import moment from 'moment';//日期格式化导包
import $ from 'jquery';
import { partnerCheckLogin } from '../newMain/partnerMain';

import saveImg from '../../public/img/newMain/Save.png';
import requestDocumentsImg from '../../public/img/newMain/RequestDocuments.png';
import makeOfferImg from '../../public/img/newMain/MakeOffer.png';
import DeclineImg from '../../public/img/newMain/Decline.png';
import tag1 from '../../public/img/tag/tag1.png';
import tag2 from '../../public/img/tag/tag2.png';
import studentDefaultPictureImg from '../../public/img/newMain/studentDefaultPicture.png'

import './partnerReviewStudentApplication.css';
import MessageRejected from './messageRejected';
import Confirm from '../../component/confirm/confirm';

const { TextArea } = Input;

const PartnerReviewStudentApplication = (props) => {
    const history = useHistory();
    const { jobApplId } = useParams();
    const messageRef = useRef();
    const messageRef2 = useRef();
    const messageRef3 = useRef();
    const messageRef4 = useRef();
    const messageSalaryRef = useRef();
    const confirmRef = useRef();
    const [model, setModel] = useState({})
    const [jobApplModel, setJobApplModel] = useState({});
    const [jobPostStatus, setJobPostStatus] = useState("");
    const [isVisible, setIsVisible] = useState(false);
    const [flag, setFlag] = useState("");
    const [isLoad, setIsLoad] = useState(false);
    const messageReasonRef = useRef();

    const jobpostStatusMap = {
        DRAFT: "Draft",
        SUBMITTED: "THEi Reviewing",
        ACTIVE: "Active",
        REJECTED: "THEi Rejected",
        EXPIRED: "Expired",
        WITHDRAWN: "Withdrawn",
    }

    const interviewStatusMap = {
        IP_SCHEDULING_INTERVIEW: "IP Scheduling Interview",
        STUDENT_NO_SHOW: "Interview - Student No Show",
        IP_WITHDRAW: "Interview - IP Withdraw",
        INTERVIEWED: "Interviewed",
        "N/A": "N/A",
    }

    useEffect(() => {
        if (!Config.partnerInfo?.partnerId) {
            partnerCheckLogin();
        }
        searchJobApplById(jobApplId);
    }, []);

    const searchJobApplById = (jobApplId, flag) => {
        let model = {
            jobApplId: jobApplId,
            cohortYear: Config.cohort?.cohortYear,
            flag: flag ?? ''
        }
        Base.callBackApi("partnerStudentAppl/searchById", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                let model = data.object ?? {};
                setJobApplModel(model);
                setJobPostStatus(model.jobApplStatus)
                let jobDesc = model?.jobDesc?.replace(/\\/g, "/")?.replace(/&nbsp;/g, ' ');
                $("#jobDesc").empty().append(jobDesc);
                let jobRequirement = model?.jobRequirement?.replace(/\\/g, "/")?.replace(/&nbsp;/g, ' ');
                $("#jobRequirement").empty().append(jobRequirement);
                let companyProfile = model?.companyProfile?.replace(/\\/g, "/")?.replace(/&nbsp;/g, ' ');
                $("#companyProfile").empty().append(companyProfile);
            } else {
                message.error(data.msg)
            }
        })
    }

    const jump = (path) => {
        history.push(path);
    }

    const errFrameShow = () => {
        messageRef.current.setContent("You've requested the student to provide supplementary documents to be considered the position. Let the students know what you wish to see.")
        messageRef.current.setMsg("")
        messageRef.current.setIsShow(true)
    }

    const done = (flag, eventRemark) => {
        if (flag === "save") {
            messageRef.current.setIsShow(false);
            requestDocuments(eventRemark);
        }
        messageRef.current.setIsShow(false);
    }

    const errFrameShowSalary = () => {
        messageSalaryRef.current.setContent("Please input the addition information below if any.");
        messageSalaryRef.current.setHkd();
        messageSalaryRef.current.setIsShow(true);
    }

    const doneSalary = (flag, eventRemark) => {
        if (flag === "save") {
            messageSalaryRef.current.setIsShow(false);
            makeOffer(eventRemark);
        }
        messageSalaryRef.current.setIsShow(false);

    }

    const confirm = (flag) => {
        confirmRef.current.setIsShow(false);
        if (flag) {
            declineAppl()
        }
    }

    const decline = () => {
        confirmRef.current.setIsShow(true)
        confirmRef.current.setContent("Please confirm if you are declining this student's job application.")
    }

    const done2 = () => {
        messageRef2.current.setIsShow(false)
        searchJobApplById(jobApplId);
    }

    const done4 = () => {
        messageRef4.current.setIsShow(false)
        searchJobApplById(jobApplId);
    }

    const errFrameShow2 = (msg, flag) => {
        messageRef2.current.setContent(msg)
        messageRef2.current.setIsShow(true)
        messageRef2.current.setStatusFlag(flag)
    }

    const done3 = () => {
        messageRef3.current.setIsShow(false);
        searchJobApplById(jobApplId, 'OFFER');
    }

    const makeOffer = (remark) => {
        if (isLoad) {
            return;
        }
        let model = {
            jobApplId: jobApplModel.jobApplId,
            jobId: jobApplModel.jobId,
            lastUpdatedDate: jobApplModel.lastUpdatedDate,
            eventRemark: remark,
            interviewStatus: jobApplModel.interviewStatus,
            ipNotes: jobApplModel.ipNotes,
        }
        model.menuFuncId = Config.funcInfo.funcId;
        setIsLoad(true);
        Base.callBackApi("partnerStudentAppl/makeOffer", model).then((data) => {
            if ("SUCCESS" === data?.msg) {
                messageRef3.current.setContent("You have made an offer to this student. The student will be notified shortly.")
                messageRef3.current.setIsShow(true)
            } else {
                message.error(data?.msg)
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const declineAppl = () => {
        if (isLoad) {
            return;
        }
        let model = {
            jobApplId: jobApplModel.jobApplId,
            jobId: jobApplModel.jobId,
            lastUpdatedDate: jobApplModel.lastUpdatedDate,
            ipNotes: jobApplModel.ipNotes,
        }
        model.menuFuncId = Config.funcInfo.funcId;
        setIsLoad(true);
        Base.callBackApi("partnerStudentAppl/decline", model).then((data) => {
            if ("SUCCESS" === data?.msg) {
                errFrameShow2("The student applicant will be notified that their job application will not be pursued any further.", true);
            } else {
                message.error(data?.msg)
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const saveinterviewStatus = () => {
        if (isLoad) {
            return;
        }
        let model = {
            jobApplId: jobApplModel.jobApplId,
            jobId: jobApplModel.jobId,
            lastUpdatedDate: jobApplModel.lastUpdatedDate,
            interviewStatus: jobApplModel.interviewStatus,
            ipNotes: jobApplModel.ipNotes,
        }
        model.menuFuncId = Config.funcInfo.funcId;
        setIsLoad(true);
        Base.callBackApi("partnerStudentAppl/saveInterviewStatus", model).then((data) => {
            if ("SUCCESS" === data?.msg) {
                messageRef4.current.setIsShow(true)
                messageRef4.current.setContent('Save successfully.')
            } else {
                message.error(data?.msg)
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const requestDocuments = (remark) => {
        if (isLoad) {
            return;
        }
        let model = {
            jobApplId: jobApplModel.jobApplId,
            jobId: jobApplModel.jobId,
            lastUpdatedDate: jobApplModel.lastUpdatedDate,
            eventRemark: remark,
            interviewStatus: jobApplModel.interviewStatus,
            ipNotes: jobApplModel.ipNotes
        }
        model.menuFuncId = Config.funcInfo.funcId;
        setIsLoad(true);
        Base.callBackApi("partnerStudentAppl/requestDocuments", model).then((data) => {
            if ("SUCCESS" === data?.msg) {
                errFrameShow2("You've requested the student to provide supplementary documents to be considered the position.", true)
            } else {
                message.error(data?.msg)
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const downloadFile = (item, flag) => {
        if (!Base.stopClick()){
            return;
        }
        if (flag) {
            item.url = Config.studentFiles + item.path;
        } else {
            item.url = Config.jobApplFiles + item.path;
        }
        Base.downloadFile(item.url + '?' + Config.sasToken, item.name)
        // if (isLoad) {
        //     return;
        // }
        // if (item.lastModified) {
        //     return;
        // }
        // if (flag) {
        //     item.code = "STUDENT_PATH";
        // } else {
        //     item.code = "JOB_APPL_PATH";
        // }
        // setIsLoad(true);
        // fetch(Config.apiDownloadServer + "downloadFile/downloadFile", {
        //     method: 'POST',
        //     body: JSON.stringify(item),
        //     headers: Config.header,
        //     mode: 'cors',
        //     cache: 'default'
        // }).then(res => res.blob()).then(blob => {
        //     if (blob.type == "application/json") {
        //         var reader = new FileReader();
        //         reader.onload = e => {
        //             var data = JSON.parse(e.target.result);
        //             message.error(data.msg);
        //         }
        //         reader.readAsText(blob);
        //     } else {
        //         if (window.navigator && window.navigator.msSaveOrOpenBlob) {// for IE
        //             window.navigator.msSaveOrOpenBlob(blob, item.name);
        //         } else {// for Non-IE (chrome, firefox etc.)
        //             var a = document.createElement('a');
        //             document.body.appendChild(a);
        //             a.style = 'display: none';
        //             var url = window.URL.createObjectURL(blob);
        //             a.href = url;
        //             a.download = item.name;
        //             a.click();
        //             a.remove();
        //             window.URL.revokeObjectURL(url);
        //         }
        //     }
        // }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const modelChange = (key, value) => {
        setJobApplModel(model => {
            return { ...model, ...{ [key]: value } };
        });
    }

    const opendialogMessageReason = (param) => {
        messageReasonRef.current.setContent(param)
        messageReasonRef.current.setIsShow(true)
    }

    const messageReasonDone = (flag, eventRemark) => {
        if (flag === 'save') {
            requestDocuments(eventRemark);
        }
        messageReasonRef.current.setIsShow(false)
    }

    const generatePdf = (model) => {
        if (isLoad) {
            return;
        }
        setIsLoad(true);
        fetch(Config.apiDownloadServer + "partnerReviewStudentApplicationPdf/generatePdf", {
            method: 'POST',
            body: JSON.stringify(model),
            headers: Config.header,
            mode: 'cors',
            cache: 'default'
        }).then(res => res.blob()).then(blob => {
            if (blob.type == "application/json") {
                var reader = new FileReader();
                reader.onload = e => {
                    var data = JSON.parse(e.target.result);
                    console.log(data);
                    // errFrameShow("error", data.msg);
                }
                reader.readAsText(blob);
            } else {
                var filename = "PartnerReviewStudentApplication" + moment(new Date()).format(Config.dateFormat3) + Base.generateFourDigitRandomNumber() + ".pdf";
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {// for IE
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {// for Non-IE (chrome, firefox etc.)
                    var a = document.createElement('a');
                    document.body.appendChild(a);
                    a.style = 'display: none';
                    var url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = filename;
                    a.click();
                    a.remove();
                    window.URL.revokeObjectURL(url);
                }
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    return (
        <div id="container" className='websiteTemplate partnerReviewStudentApplication'>
            {/* <MessageLetter ref={messageRef} done={done} cancel={cancel} /> */}
            <MessageRejected ref={messageReasonRef} done={messageReasonDone} />
            <MessageLetter ref={messageRef} done={done} />
            <NewMessage ref={messageRef3} done={done3} />
            <NewMessage ref={messageRef2} done={done2} />
            <NewMessage ref={messageRef4} done={done4} />
            <MessageSalary ref={messageSalaryRef} done={doneSalary} />
            <Confirm ref={confirmRef} done={confirm} />
            <Spin size="large" spinning={isLoad} >
                <div className='websiteSysButtonRow'>
                    <div className='detailStatusBox'>
                        <div className="detailTitle">Review Student Application</div>
                        <div className='flexQuestionCircleBox'>
                            <div className={'statusTitleBox ' + (jobApplModel.jobApplStatus)}>{ContextHandler.getMapValue("partnerJobApplStatusMap", jobApplModel.jobApplStatus)}</div>
                            {jobApplModel?.specialArrange === 'Y' && <Popover placement="bottom" content={
                                <div style={{maxWidth: "500px", textAlign: 'justify'}}>
                                    {'The Programme Module Convener has designated the mode of application for this Job Post as "Special Arrangement", which means the application will be submitted outside of this digital platform according to a prior agreement with the Industry Partner.'}
                                    <br></br><br></br>
                                    The Module Convener will provide instructions to the student regarding the specific submission mode.
                                    <br></br><br></br>
                                    No action is required from the Industry Partner for this job application record.
                                </div>
                            } trigger="hover" >
                                <div className='questionCircle' ><QuestionCircleOutlined /></div>
                            </Popover>}
                        </div>

                    </div>
                    <div className="websiteSysButtonBox">
                        {
                            jobApplModel.jobApplStatus == "IP_PROCESSING" || jobApplModel.jobApplStatus == "DOCUMENT_SUBMITTED" ?
                                <>
                                    <div className='websiteSysButton' style={{ color: '#FFFFFF', backgroundColor: '#0BBB5C' }} onClick={() => errFrameShowSalary()}><img src={makeOfferImg} />Make Offer</div>
                                    <div className='websiteSysButton' style={{ color: '#FFFFFF', backgroundColor: '#D71020' }} onClick={() => decline()}><img src={DeclineImg} />Decline</div>
                                    {jobApplModel.jobApplStatus == "IP_PROCESSING" && <div className='websiteSysButton' style={{ color: '#FFFFFF', backgroundColor: '#0059AC' }} onClick={() => opendialogMessageReason("Please input here for requesting more information, it will be sent to the student for action and visible to the module convenor.")}><img src={requestDocumentsImg} />Request More Info</div>}
                                </> : ""
                        }
                    </div>
                </div>
                <div className="websiteSysContentBox">
                    <div className='detailPrintButtonTopBox'></div>
                    <Button className="websiteSysButton detailPrintButton" onClick={() => generatePdf(jobApplModel)} style={{ color: '#FFFFFF', backgroundColor: '#0059AC' }} type="primary" icon={<PrinterOutlined style={{ fontSize: "18px" }} />}>Print</Button>
                    <div className='websiteSysContent'>
                        <div style={{ display: 'flex' }}>
                            <div className='label'>IP Comment Section</div>
                            <Popover placement="bottom" content={<div>
                                This section is strictly accessible to the Industry Partner and not visible to <br></br>
                                any other users.<br></br><br></br>
                                It is designed to facilitate the recruiter in tracking and making notes on <br></br>
                                the vetting process.
                            </div>} trigger="hover" >
                                <div className='questionCircle' style={{ marginLeft: '10px' }} ><QuestionCircleOutlined /></div>
                            </Popover>
                        </div>
                        <div className='interviewStatusDiv'>
                            <div className='interviewStatusBox'>
                                <div className='label'>Interview Status</div>
                                {/* {jobApplModel.jobApplStatus == "IP_PROCESSING" || jobApplModel.jobApplStatus == "DOCUMENT_SUBMITTED" ? */}
                                <div className='websiteSysInput'>
                                    <Select className='sysSelect'
                                        value={jobApplModel.interviewStatus}
                                        onChange={(value) => modelChange('interviewStatus', value)}
                                        getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                    >
                                        <Select.Option value=''></Select.Option>
                                        {context.interviewStatusMap.map((item) => <Select.Option key={item.value} value={item.value}>{item.label}</Select.Option>)}
                                    </Select>
                                </div>
                                {/* <div className='value'>{interviewStatusMap[jobApplModel.interviewStatus]}</div> */}
                            </div>
                            <div className='interviewStatusBox'>
                                <div className='label'>{"IP's Private Notes"}</div>
                                {/* {jobApplModel.jobApplStatus == "IP_PROCESSING" || jobApplModel.jobApplStatus == "DOCUMENT_SUBMITTED" ? */}
                                <div className='websiteSysInputMax'>
                                    <TextArea value={jobApplModel.ipNotes} maxLength={500} rows={3} placeholder=""
                                        onChange={(e) => modelChange('ipNotes', e.target.value)} />
                                </div>
                                {/* <div className='value'>{jobApplModel.ipNotes}</div> */}
                            </div>
                            <div className='websiteSysButtonBox'>
                                <Button className="websiteSysButton" style={{ color: '#FFFFFF', backgroundColor: '#0059AC' }} type="primary"
                                    onClick={() => saveinterviewStatus()}><img src={saveImg} />Save</Button>
                            </div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>Job ID</div>
                            <div className='value'>{jobApplModel.jobId}</div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>
                                Job Title
                            </div>
                            <div className='value'>
                                {jobApplModel.jobTitle}
                            </div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>
                                Job Post Status
                            </div>
                            <div className='value'>
                                {jobpostStatusMap[jobApplModel?.jobPostStatus]}
                            </div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>Designated THEi Programme</div>
                            <div className='value'>
                                {jobApplModel.progTitle}
                            </div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>
                                Employment Type
                            </div>
                            <div className='value'>
                                {jobApplModel.jobTypeVal}
                            </div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>
                                Job Mode
                            </div>
                            <div className='value'>
                                {jobApplModel.positionTypeVal}
                            </div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>
                                Salary (HKD)
                            </div>
                            <div className='value'>
                                {jobApplModel.salaryRangeFrom} ~ {jobApplModel.salaryRangeTo}
                            </div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>
                                Salary Basis
                            </div>
                            <div className='value'>
                                {jobApplModel.unitVal}
                            </div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>
                                Expected Commence Date
                            </div>
                            <div className='value'>
                                {jobApplModel.expCommenceDate ? moment(jobApplModel.expCommenceDate).format(Config.dateFormatEn) : ''}
                            </div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>
                                Expected End Date
                            </div>
                            <div className='value'>
                                {jobApplModel.expEndDate ? moment(jobApplModel.expEndDate).format(Config.dateFormatEn) : ''}
                            </div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>
                                Application Deadline
                            </div>
                            <div className='value'>
                                {jobApplModel.lastApplyDate ? moment(jobApplModel.lastApplyDate).format(Config.dateFormatEn) : ''}
                            </div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>
                                Number of Vacancy
                            </div>
                            <div className='value'>
                                {jobApplModel.vacancy}
                            </div>
                        </div>
                        <div className='flexBox marginTop15px'>
                            <div className='label'>
                                Job Description
                            </div>
                        </div>
                        <div id='jobDesc' className='text valueJustify'>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>
                                Job Requirement
                            </div>
                        </div>
                        <div id='jobRequirement' className='text valueJustify'>
                        </div>
                        <div className='detailButtonBox'>
                            <Button className="websiteSysButton" style={{ color: '#FFFFFF', backgroundColor: '#0059AC' }} type="primary" icon={<EyeOutlined style={{ fontSize: "18px" }} />}
                                onClick={() => jump('/partner/partnerJobPostingDetail/' + jobApplModel.jobId + '/view')}>Job Posting Detail</Button>
                            {/* <div className='websiteSysButton' style={{ color: '#FFFFFF', backgroundColor: '#0059AC' }} onClick={()=>jump('/partner/partnerJobPostingDetail/' + jobApplModel.jobId + '/view')}>Job Posting Detail</div> */}
                        </div>
                    </div>
                    <div className='contentCenterLine'></div>
                    <div className='websiteSysContent'>
                        <div className='detailPrintButtonBox'></div>
                        <div className='flexBox'>
                            <div className='label'>Student Profile Picture</div>
                            <div className='value'>
                                <img src={jobApplModel.studentPhoto ? Config.studentPhotoImg + jobApplModel.studentPhoto + '?' + Config.sasToken : studentDefaultPictureImg} />
                            </div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>Job Application Status</div>
                            <div className='value'>{ContextHandler.getMapValue("partnerJobApplStatusMap", jobApplModel.jobApplStatus)}</div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>Application ID</div>
                            <div className='value'>{jobApplModel.jobApplId}</div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>
                                Date Applied
                            </div>
                            <div className='value'>
                                {jobApplModel.applyDate ? moment(jobApplModel.applyDate).format(Config.dateFormatEn) : ''}
                            </div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>Student ID</div>
                            <div className='value'>{jobApplModel.studentAcctId}</div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>Student Name</div>
                            <div className='value'>{(jobApplModel.firstName ?? '') + ' ' + (jobApplModel.lastName ?? '')}</div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>Programme Enrolled</div>
                            <div className='value'>{jobApplModel.studentProgTitle}</div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>Email</div>
                            <div className='value'>{jobApplModel.email}</div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>Contact Phone</div>
                            <div className='value'>{jobApplModel.contactPhone}</div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>WhatsApp</div>
                            <div className='value'>{jobApplModel.whatsApp}</div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>Wechat</div>
                            <div className='value'>{jobApplModel.weChat}</div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>LinkedIn</div>
                            <div className='value'>{jobApplModel.linkedIn}</div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>Personal Web</div>
                            <a href={(jobApplModel.personalWeb && !jobApplModel.personalWeb.startsWith('https://')) ? 'https://' + jobApplModel.personalWeb : jobApplModel.personalWeb} target="_blank" rel="noreferrer">{jobApplModel.personalWeb}</a>
                        </div>
                        <div className='flexDocumentBox'>
                            <div className='label'>Resume</div>
                            {
                                jobApplModel.annexName && <div className='tag' title={jobApplModel.annexName} onClick={() => downloadFile({ name: jobApplModel.annexName, path: jobApplModel.storagePath }, jobApplModel.resumeType === 'SELECT')}>
                                    <img src={tag1} className="tagImg"></img>{jobApplModel.annexName}
                                </div>
                            }
                        </div>
                        <div className='flexBox'>
                            <div className='label'>Portfolio Link</div>
                            <div className='linkBox'>
                                {jobApplModel.portfolioLinkOne &&
                                    <div className='tag'>
                                        <img src={tag2} className="tagImg"></img><a href={(jobApplModel.portfolioLinkOne && !jobApplModel.portfolioLinkOne.startsWith('https://')) ? 'https://' + jobApplModel.portfolioLinkOne : jobApplModel.portfolioLinkOne} title={jobApplModel.portfolioLinkOne} target="_blank" rel="noreferrer">{jobApplModel.portfolioLinkOneDesc ? jobApplModel.portfolioLinkOneDesc : jobApplModel.portfolioLinkOne}</a>
                                    </div>
                                }
                                {jobApplModel.portfolioLinkTwo &&
                                    <div className='tag'>
                                        <img src={tag2} className="tagImg"></img><a href={(jobApplModel.portfolioLinkTwo && !jobApplModel.portfolioLinkTwo.startsWith('https://')) ? 'https://' + jobApplModel.portfolioLinkTwo : jobApplModel.portfolioLinkTwo} title={jobApplModel.portfolioLinkTwo} target="_blank" rel="noreferrer">{jobApplModel.portfolioLinkTwoDesc ? jobApplModel.portfolioLinkTwoDesc : jobApplModel.portfolioLinkTwo}</a>
                                    </div>
                                }
                                {jobApplModel.portfolioLinkThree &&
                                    <div className='tag'>
                                        <img src={tag2} className="tagImg"></img><a href={(jobApplModel.portfolioLinkThree && !jobApplModel.portfolioLinkThree.startsWith('https://')) ? 'https://' + jobApplModel.portfolioLinkThree : jobApplModel.portfolioLinkThree} title={jobApplModel.portfolioLinkThree} target="_blank" rel="noreferrer">{jobApplModel.portfolioLinkThreeDesc ? jobApplModel.portfolioLinkThreeDesc : jobApplModel.portfolioLinkThree}</a>
                                    </div>
                                }
                            </div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>Additional Attachment</div>
                        </div>
                        <div className='documentDiv'>
                            {jobApplModel.jobApplAnnexModelList?.map(item =>
                                !item.jobApplEventId && <div className='flexDocumentBox' key={item.jobApplAnnexId}>
                                    <div className='label'>{item.fileTypeVal}</div>
                                    <div className='tag' key={item.jobApplAnnexId} title={item.annexName} onClick={() => downloadFile({ name: item.annexName, path: item.storagePath })}>
                                        <img src={tag1} className="tagImg"></img>{item.annexName}
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className='flexBox'>
                            <div className='label'>Additional Comment</div>
                            <div className='valueJustify value2'>{jobApplModel.additionalInfo}</div>
                        </div>
                        <div className='flexBox'></div>
                        {jobApplModel?.eventRequestDocumentList?.map((item, index) =>
                            <div key={index} className='documentRemarkBox'>
                                <div className='flexBox'>
                                    <div className='label'><span style={{ color: '#0059AC', fontWeight: 'bold' }}>{index + 1} </span>IP Request More Info</div>
                                    <div className='valueJustify value2'>{item.eventRemark}</div>
                                </div>
                                {jobApplModel?.eventDocumenAttachedList[index] &&
                                    <>
                                        {jobApplModel?.eventDocumenAttachedList[index]?.eventRemark &&
                                            <div className='flexBox'>
                                                <div className='label'>Additional Information</div>
                                                <div className='valueJustify value2'>{jobApplModel?.eventDocumenAttachedList[index]?.eventRemark}</div>
                                            </div>
                                        }
                                        {
                                            item?.jobApplAnnexModelList?.map((item, i) =>
                                                <div className='flexDocumentBox' key={i}>
                                                    {
                                                        i == 0 ? <div className='label'>Additional Attachment</div> : <div className='label'></div>
                                                    }
                                                    <div className='tag' key={item.jobApplAnnexId} title={item.annexName} onClick={() => downloadFile({ name: item.annexName, path: item.storagePath })}>
                                                        <img src={tag1} className="tagImg"></img>{item.annexName}
                                                    </div>
                                                </div>
                                            )}
                                    </>
                                }
                            </div>
                        )}
                        <div className='flexBox'></div>
                        {jobApplModel?.eventDialogList?.map((item, index) => 
                            !Base.isEmptyObject(item) && <div key={index} className='documentRemarkBox'>
                                <div className='flexBox'>
                                    <div className='label'>Application<span style={{ color: '#0059AC', fontWeight: 'bold' }}> {index + 1} </span>Dialog</div>
                                </div>
                                {item?.studentWithdawnRemark && <div className='flexBox'>
                                    <div className='label'>Withdrawn Job Application Reason</div>
                                    <div className='valueJustify value2'>{item.studentWithdawnRemark}</div>
                                </div>}
                                {item?.specialRemark && <div className='flexBox'>
                                    <div className='label'>Special Arrangement Remark</div>
                                    <div className='valueJustify value2'>{item.specialRemark}</div>
                                </div>}
                                {item?.offerEventRemark && <div className='flexBox'>
                                    <div className='label'>IP Make Offer Additional Info</div>
                                    <div className='valueJustify value2'>{item.offerEventRemark}</div>
                                </div>}
                                {item?.offerDeclinedRemark && <div className='flexBox'>
                                    <div className='label'>Offer Rejected Reason</div>
                                    <div className='valueJustify value2'>{item.offerDeclinedRemark}</div>
                                </div>}
                            </div>
                        )}
                    </div>
                </div>
                <div className="websiteSysButtonBox">
                    {
                        jobApplModel.jobApplStatus == "IP_PROCESSING" || jobApplModel.jobApplStatus == "DOCUMENT_SUBMITTED" ?
                            <>
                                <div className='websiteSysButton' style={{ color: '#FFFFFF', backgroundColor: '#0BBB5C' }} onClick={() => errFrameShowSalary()}><img src={makeOfferImg} />Make Offer</div>
                                <div className='websiteSysButton' style={{ color: '#FFFFFF', backgroundColor: '#D71020' }} onClick={() => decline()}><img src={DeclineImg} />Decline</div>
                                {jobApplModel.jobApplStatus == "IP_PROCESSING" && <div className='websiteSysButton' style={{ color: '#FFFFFF', backgroundColor: '#0059AC' }} onClick={() => opendialogMessageReason("Please input here for requesting more information, it will be sent to the student for action and visible to the module convenor.")}><img src={requestDocumentsImg} />Request More Info</div>}
                            </> : ""
                    }
                </div>
            </Spin>
        </div>
    )

}

export default PartnerReviewStudentApplication;